import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=068820a4&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=ts&"
export * from "./Base.vue?vue&type=script&lang=ts&"
import style0 from "./Base.vue?vue&type=style&index=0&id=068820a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068820a4",
  null
  
)

export default component.exports